import React, { useState, useContext } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBinoculars } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";


const CRMModalGestion = ({
    show,
    onHide,
    cliente,
    acciones = [],
    onRecargarTabla
}) => {
    const { darkMode } = useContext(DarkModeContext);
    const [loading, setLoading] = useState(false);

    // Estado interno del formulario
    const [formGestion, setFormGestion] = useState({
        idRegla: "",
        observacion: ""
    });

    const handleChange = (campo, valor) => {
        setFormGestion({ ...formGestion, [campo]: valor });
    };

    // Función para limpiar el nombre y quitar etiquetas técnicas
    const formatearNombre = (nombre) => {
        if (!nombre) return "Cliente";
        return nombre.replace("[NUEVO]", "").replace("Prospecto:", "").split("|")[0].trim();
    };

    // --- LA CONSULTA AL BACKEND ---
    const handleConfirmar = async () => {
        if (!formGestion.idRegla) {
            return Swal.fire("Atención", "Debes seleccionar una acción realizada", "warning");
        }

        setLoading(true);
        const token = getToken();

        const requestBody = {
            Token: token,
            IdSeguimientoAnterior: cliente.id, // El ID de la alerta actual
            IdReglaNueva: parseInt(formGestion.idRegla),
            Observacion: formGestion.observacion,
            IdAlta: cliente.idAlta || null
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_CRM_REGISTRAR_GESTION, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });

            // Manejo de respuesta JSON o Texto
            let data;
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            } else {
                const text = await response.text();
                data = { mensaje: text };
            }

            if (response.ok) {
                Swal.fire("Éxito", "Gestión guardada y recontacto programado", "success");

                // Limpiamos el modal
                setFormGestion({ idRegla: "", observacion: "" });

                // Avisamos al padre para refrescar la tabla
                if (onRecargarTabla) onRecargarTabla();

                // Cerramos
                onHide();
            } else {
                Swal.fire("Error", data.mensaje || "No se pudo registrar la gestión", "error");
            }
        } catch (error) {
            console.error("Error en fetch:", error);
            Swal.fire("Error", "Error de conexión con el servidor", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered className={darkMode ? "text-dark" : ""}>
            <Modal.Header closeButton className="bg-success text-white">
                <Modal.Title>
                    <FontAwesomeIcon icon={faBinoculars} className="me-2" />
                    Registrar Seguimiento
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {cliente && (
                    <Alert variant="info" className="border-0 shadow-sm">
                        <div className="fw-bold" style={{ fontSize: "1.1rem" }}>
                            {formatearNombre(cliente.nombreCliente)}
                        </div>
                        <div className="text-muted small">
                            Acción previa: {cliente.titulo}
                        </div>
                        <div className="text-muted small mt-1">
                            CUIT: {cliente.cuit || ""}
                        </div>
                        <div className="text-muted small">
                            TEL: {cliente.telefono || ""}
                        </div>
                    </Alert>
                )}

                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">¿Qué se hizo en este contacto? *</Form.Label>
                        <Form.Select
                            value={formGestion.idRegla}
                            onChange={(e) => handleChange("idRegla", e.target.value)}
                            disabled={loading}
                        >
                            <option value="">-- Seleccione una acción --</option>
                            {acciones && acciones.map((acc) => (
                                <option key={acc.id} value={acc.id}>
                                    {acc.aliasVista}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Observaciones del contacto:</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Escribe detalles importantes aquí..."
                            value={formGestion.observacion}
                            onChange={(e) => handleChange("observacion", e.target.value)}
                            disabled={loading}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    variant="success"
                    onClick={handleConfirmar}
                    disabled={loading || !formGestion.idRegla}
                    className="px-4 fw-bold"
                >
                    {loading ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                            Guardar Gestión
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CRMModalGestion;
